/**
 * Context for features requested by a query parameter.
 * Do not confuse with organization features which are handled elsewhere.
 */

import React from 'react';

export const FeatureContext = React.createContext<string[]>([]);

FeatureContext.displayName = 'FeatureContext';

export default FeatureContext;
